import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import DesktopNavigation from './components/DesktopNavigation';
import BottomNavigation from './components/BottomNavigation';
import ProductsScreen from './components/ProductsScreen';
import ProductDetailScreen from './components/ProductDetailScreen';
import CartScreen from './components/CartScreen';
import CheckoutScreen from './components/CheckoutScreen';
import { ToastProvider } from './components/Toast';
import './App.css';

function App() {
  const RouteChangeTrigger: React.FC = () => {
    const location = useLocation();
    React.useEffect(() => {
      // Skip route-change trigger if we just handled a specific event
      const lastEventTime = (window as any).__lastFpEventTime || 0;
      const now = Date.now();
      if (now - lastEventTime < 1000) {
        return;
      }

      // Lazy import to avoid circular dep at module init
      import('./utils/fingerprint').then(({ loadFingerprintIfNeeded }) => {
        void loadFingerprintIfNeeded('route-change');
      });
    }, [location.pathname, location.search, location.hash]);
    return null;
  };

  const router = createBrowserRouter(
    [
      {
        path: '/',
        element: (
          <ToastProvider>
            <div className="app">
              <DesktopNavigation />
              <main className="main-content">
                <RouteChangeTrigger />
                <Outlet />
              </main>
              <BottomNavigation />
            </div>
          </ToastProvider>
        ),
        children: [
          { index: true, element: <ProductsScreen /> },
          { path: 'product/:productId', element: <ProductDetailScreen /> },
          { path: 'cart', element: <CartScreen /> },
          { path: 'checkout', element: <CheckoutScreen /> },
        ],
      },
    ],
    {
      future: ({
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      } as any),
    }
  );

  return (
    <CartProvider>
      <RouterProvider router={router} />
    </CartProvider>
  );
}

export default App;
